"use client";

// ============================================================
// CLUBHUB – Pinnwand: Register und kleine Teile
// ============================================================
import { Landmark, Users } from "lucide-react";
import { RegisterLeiste } from "@/components/ui";
import { Farbpunkt } from "@/components/gruppen/zeichen";
import type { PostAudience } from "@/generated/prisma/enums";
import { POST_AUDIENCE } from "@/lib/labels";
import { istAbgelaufen } from "@/lib/pinnwand/logik";
import { cn } from "@/lib/utils";
import { usePinnwand } from "./pinnwand-bestand";

/** Aushaenge | Aufgaben — mit dem, was gerade zaehlt. */
export function PinnwandRegister() {
  const { aushaenge, aufgaben, jetzt } = usePinnwand();
  return (
    <RegisterLeiste
      basis="/pinnwand"
      register={[
        { schluessel: "", label: "Aushänge", zaehler: aushaenge.filter((a) => !istAbgelaufen(a, jetzt)).length },
        { schluessel: "aufgaben", label: "Aufgaben", zaehler: aufgaben.filter((a) => a.status !== "DONE").length },
      ]}
    />
  );
}

/** Fuer wen der Aushang ist — „Alle Mitglieder“, „Vorstand“ oder die Gruppe mit ihrer Farbe. */
export function ZielEtikett({
  audience,
  groupId,
  className,
}: {
  audience: PostAudience;
  groupId: string | null;
  className?: string;
}) {
  const { gruppen } = usePinnwand();
  const gruppe = audience === "GROUP" ? gruppen.find((g) => g.id === groupId) : undefined;
  return (
    <span
      className={cn(
        "bg-bg-tertiary text-caption text-text-secondary inline-flex max-w-full items-center gap-1.5 rounded-full px-2 py-0.5 font-medium whitespace-nowrap",
        className,
      )}
    >
      {audience === "ALL" && <Users className="h-3 w-3 shrink-0" aria-hidden />}
      {audience === "BOARD" && <Landmark className="h-3 w-3 shrink-0" aria-hidden />}
      {audience === "GROUP" && <Farbpunkt farbe={gruppe?.color ?? null} className="h-2 w-2" />}
      <span className="truncate">{audience === "GROUP" ? (gruppe?.name ?? "Gruppe") : POST_AUDIENCE[audience]}</span>
    </span>
  );
}

/** Vor- und Nachname fuer den Kreis aus einem Anzeigenamen „Vorname Nachname“. */
export function namensTeile(name: string): { firstName: string; lastName: string } {
  const teile = name.trim().split(/\s+/);
  return { firstName: teile[0] ?? "?", lastName: teile.slice(1).join(" ") };
}
